/**
 * Copies a discount code to the clipboard and confirms it (visually and for screen readers).
 * Markup: sections/announcement-usp.liquid
 */
class CopyCode extends HTMLElement {
  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    this.button = this.querySelector('button');
    this.status = this.querySelector('[data-copy-status]');
    this.live = this.querySelector('[data-copy-live]');
    this.defaultLabel = this.status?.textContent ?? '';
    this.button?.addEventListener('click', this.#copy);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#copy);
  }

  #copy = async () => {
    const code = this.dataset.code || '';
    if (!code) return;
    let copied = false;
    try {
      await navigator.clipboard.writeText(code);
      copied = true;
    } catch {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.append(field);
      field.select();
      try {
        copied = document.execCommand('copy');
      } catch {
        copied = false;
      }
      field.remove();
    }
    if (!copied) return;

    const message = this.dataset.copied || '';
    if (this.status) this.status.textContent = message;
    if (this.live) this.live.textContent = message;
    clearTimeout(this.#timer);
    this.#timer = window.setTimeout(() => {
      if (this.status) this.status.textContent = this.defaultLabel;
      if (this.live) this.live.textContent = '';
    }, 2000);
  };
}

if (!customElements.get('copy-code')) customElements.define('copy-code', CopyCode);
